<template>
    <div>
        <b-row>
            <b-col v-for="(comms_payout_summary, index) in comms_payout_summaries" :key="comms_payout_summary.comms_payout_summary_id">
                <div v-if="index == 0">Recruitment Payout</div>
                <div v-else>Advisory Recruitment Payout</div>
                <table class="table table-bordered" width="100%" >
                    <thead>
                        <tr>
                            <th class="bg-dark text-white py-2">#</th>
                            <th class="bg-dark text-white py-2">User</th>
                            <th class="bg-dark text-white py-2">Payout <br>Level</th>
                            <th class="bg-dark text-white py-2">Total Revenue Point</th>
                            <th class="bg-dark text-white py-2">Payout <br>Percentage <br>(%)</th>
                            <th class="bg-dark text-white py-2" width="10px">Payout <br>Revenue Point</th>
                            <!-- <th class="bg-dark text-white py-1" width="200px">Manager Approval Status</th>
                            <th class="bg-dark text-white py-1" width="200px">Finance Approval Status</th>
                            <th class="bg-dark text-white py-1" width="200px">CEO Approval Status</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="!show_actual_revenue">
                            <tr v-for="(recruitment_payout_detail, index) in comms_payout_summary.recruitment_payout_details" :key="index">
                            <td class="py-2">{{ index+1 }}</td>
                            <td class="py-2">{{ recruitment_payout_detail.user.name }}</td>
                            <td class="py-2">{{ recruitment_payout_detail.payout_level_code }}</td>
                            <td class="py-2">RM {{ recruitment_payout_detail.total_revenue_point | moneyFormatter }}</td>
                            <td class="py-2">{{ recruitment_payout_detail.payout_percentage }}</td>
                            <td class="py-2">RM {{ recruitment_payout_detail.payout_revenue_point | moneyFormatter }}</td>
                            <!-- <template v-if="decide_mode">
                                <td class="py-1">
                                    <el-select
                                        v-model="recruitment_payout_detail.manager_approval_status" :disabled="permission.admin === false ? !permission.acceptor : !permission.admin"
                                    >
                                        <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        />
                                    </el-select>
                                </td>
                                <td class="py-1">
                                    <el-select
                                        v-model="recruitment_payout_detail.finance_approval_status" value-key="label" :disabled="permission.admin === false ? !permission.reviewer : !permission.admin"
                                    >
                                        <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        />
                                    </el-select>
                                </td>
                                <td class="py-1">
                                    <el-select
                                        v-model="recruitment_payout_detail.ceo_approval_status" :disabled="permission.admin === false ? !permission.approver : !permission.admin"
                                    >
                                        <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        />
                                    </el-select>
                                </td>
                            </template>
                            <template v-else>
                                <td class="py-1">{{ recruitment_payout_detail.manager_approval_status_name }}</td>
                                <td class="py-1">{{ recruitment_payout_detail.finance_approval_status_name }}</td>
                                <td class="py-1">{{ recruitment_payout_detail.ceo_approval_status_name }}</td>
                            </template> -->
                            </tr>
                        </template>
                        <template v-else>
                            <tr v-for="(recruitment_payout_detail, index) in comms_payout_summary.recruitment_payout_details" :key="index">
                            <td class="py-2">{{ index+1 }}</td>
                            <td class="py-2">{{ recruitment_payout_detail.user.name }}</td>
                            <td class="py-2">{{ recruitment_payout_detail.payout_level_code }}</td>
                            <td class="py-2">RM {{ recruitment_payout_detail.actual_total_revenue_point | moneyFormatter }}</td>
                            <td class="py-2">{{ recruitment_payout_detail.payout_percentage }}</td>
                            <td class="py-2">RM {{ recruitment_payout_detail.actual_payout_revenue_point | moneyFormatter }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </b-col>
        </b-row>
        
    </div>
</template>
<script>
import { Select, Option } from 'element-ui'

export default {
  props: ['comms_payout_summaries','decide_mode', 'permission', 'options', 'show_actual_revenue'],
  components: {
        [Select.name]: Select,
        [Option.name]: Option,
  }
}
</script>